export const formatImageFileSize = (size: number) => {
  const safeSize = Number.isFinite(size) ? Math.max(0, size) : 0

  if (safeSize < 1024) {
    return `${safeSize} B`
  }

  if (safeSize < 1024 * 1024) {
    return `${(safeSize / 1024).toFixed(1)} KB`
  }

  return `${(safeSize / (1024 * 1024)).toFixed(1)} MB`
}

const IMAGE_MIME_TYPE_LABELS: Record<string, string | undefined> = {
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/webp': 'WEBP',
  'image/tiff': 'TIFF',
  'image/bmp': 'BMP',
  'image/x-ms-bmp': 'BMP',
  'image/gif': 'GIF',
}
const IMAGE_EXTENSION_LABELS: Record<string, string | undefined> = {
  jpg: 'JPEG', jpeg: 'JPEG', jfif: 'JPEG', jpe: 'JPEG', jif: 'JPEG', jfi: 'JPEG',
  png: 'PNG', webp: 'WEBP',
  tif: 'TIFF', tiff: 'TIFF', bmp: 'BMP', gif: 'GIF',
}

export const formatImageFileType = (fileType?: string | null, filename?: string) => {
  const normalizedType = fileType?.toLowerCase() ?? ''
  const typeLabel = IMAGE_EXTENSION_LABELS[normalizedType] ?? IMAGE_MIME_TYPE_LABELS[normalizedType]

  if (typeLabel) return typeLabel

  const extension = filename
    ?.split(/[?#]/)[0]
    .split('.')
    .pop()
    ?.toLowerCase()

  return IMAGE_EXTENSION_LABELS[extension ?? '']
}
